import BreadcrumbsMui from "src/Components/BreadcrumbsMui/BreadcrumbsMui";
import React, { useState } from "react";
import __ from "src/utils/Translations";
import useIsAhr from "src/utils/hooks/useIsAhr";
import { useCompanyId, useCompanyName } from "src/Pages/Company/CompanyContext";
import { getCompanyBaseBreadcrumbs } from "src/Pages/Company/routerHelper";
import { Typography } from "@mui/material";
import BackButton from "src/Pages/Company/OrganizationStructure/sharedComponents/BackButton";
import { usePermission } from "src/utils/hooks/permissions/usePermissions";
import { organizationStructureLocalizationAdd } from "src/utils/RoleBasedSecurity/permissions";
import LocalizationsTable from "src/Pages/Company/OrganizationStructure/Localizations/Table/LocalizationsTable";
import { useFetchStructureData } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/api/useFetchStructureData";
import EditLocalizationModal from "src/Pages/Company/OrganizationStructure/Localizations/Modal/EditLocalizationModal";

const Localizations = () => {
  const isAhr = useIsAhr();
  const companyName = useCompanyName();
  const companyId = useCompanyId();
  const { data: structureData } = useFetchStructureData(companyId);
  const structureId: string | undefined = structureData?.[0]?.structureId;

  const hasPermissionLocalizationAdd = usePermission(
    organizationStructureLocalizationAdd
  );
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const baseBreadcrumbs = (
    getCompanyBaseBreadcrumbs(companyId, companyName) as {
      title: string;
      link: string;
    }[]
  ).map(({ title, link }) => ({
    label: title,
    to: link,
  }));

  const breadcrumbs = isAhr
    ? [
        {
          label: `${__("Zarządzanie firmą")} ${companyName}`,
          to: `/ahr`,
        },
        {
          label: __("Struktura organizacji"),
          to: `/ahr/organization-structure`,
        },
        {
          label: __("Lokalizacje"),
          to: `/ahr/organization-structure/localizations`,
        },
      ]
    : [
        ...baseBreadcrumbs,
        {
          label: __("Struktura organizacji"),
          to: `/company/edit/${companyId}/organization-structure`,
        },
        {
          label: __("Lokalizacje"),
          to: `/company/edit/${companyId}/organization-structure/localizations`,
        },
      ];

  return (
    <>
      <BreadcrumbsMui items={breadcrumbs} />
      <BackButton sx={{ mt: 4, mb: 3, p: 0 }} />
      <Typography
        sx={{ fontSize: "24px", textTransform: "uppercase", mb: 4 }}
        fontWeight="fontWeightBold"
      >
        {__("Lokalizacje")}
      </Typography>

      <LocalizationsTable
        companyId={companyId}
        structureId={structureId!}
        onAddClick={
          hasPermissionLocalizationAdd
            ? () => setIsCreateModalOpen(true)
            : undefined
        }
      />

      {isCreateModalOpen && (
        <EditLocalizationModal
          companyId={companyId}
          structureId={structureId!}
          mode="create"
          onClose={() => setIsCreateModalOpen(false)}
        />
      )}
    </>
  );
};

export default Localizations;
